
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/Layout/Layout';
import LocationsHero from '@/components/Locations/LocationsHero';
import OfficeLocations from '@/components/Locations/OfficeLocations';
import ServiceAreasList from '@/components/Locations/ServiceAreasList';
import LocationsContent from '@/components/Locations/LocationsContent';
import LocationsCTA from '@/components/Locations/LocationsCTA';

const LocationsPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Service Areas | Carolina Trophy Roofs | Eastern North Carolina Coverage</title>
        <meta name="description" content="Carolina Trophy Roofs serves Rocky Mount, Greenville, Wilson, Tarboro, Zebulon and throughout Eastern NC. Local roofing contractors with offices in Rocky Mount and Greenville." />
        <meta name="keywords" content="roofing service areas, Rocky Mount roofing, Greenville roofing, Wilson NC, Tarboro NC, Eastern NC roofing contractors" />
        <link rel="canonical" href="https://www.carolinatrophyroofs.com/locations" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Service Areas | Carolina Trophy Roofs | Eastern North Carolina" />
        <meta property="og:description" content="Professional roofing services across Eastern NC including Rocky Mount, Greenville, Wilson, and surrounding areas." />
        <meta property="og:url" content="https://www.carolinatrophyroofs.com/locations" />
        
        {/* Schema.org Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Carolina Trophy Roofs",
            "description": "Professional roofing contractor serving Eastern North Carolina",
            "areaServed": [
              { "@type": "City", "name": "Rocky Mount, NC" },
              { "@type": "City", "name": "Greenville, NC" },
              { "@type": "City", "name": "Wilson, NC" },
              { "@type": "City", "name": "Tarboro, NC" },
              { "@type": "City", "name": "Zebulon, NC" }
            ]
          })}
        </script>
      </Helmet>
      <LocationsHero />

      <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-12">
            <OfficeLocations />
            <ServiceAreasList />
            <LocationsContent />
          </div>
        </div>
      </div>

      <LocationsCTA />
    </Layout>
  );
};

export default LocationsPage;
